import gql from 'graphql-tag';

import { lessonFragment } from '~/shared/graphql-queries/lessons';
import { userFragment } from '~/shared/graphql-queries/users';

const courseCategoryFragment = `fragment CourseCategoryFragment on CourseCategory {
        _id
        id
        title
        description
        alias
        lessonTemplate
        categoryIndex
        creator {
            _id
        }
        data {
            course
            color
            isCommonCourseCategory
        }
        courseCategoryStudents {
            ...UserFragment
        }
        zeroLesson {
            ...LessonFragment
        }
        teacherLessonTemplate {
            _id
            title
        }
    }`;

export default gql`
${courseCategoryFragment}
${userFragment}
${lessonFragment}
`;

export const basicCourseCategoryFragment = gql`
  fragment BasicCourseCategoryFragment on CourseCategory {
    _id
    id
    title
    description
    alias
    studentsCount
    lessonsInTemplateCount
    image {
      path
    }
    lessonTemplate
    data {
      course
      color
      isCommonCourseCategory
    }
  }
`;

export const lightCourseCategoryFragment = gql`
  fragment LightCourseCategoryFragment on CourseCategory {
    _id
    id
    title
    description
    categoryIndex
    alias
    image {
      path
    }
    lessonTemplate
    data {
      course
      color
      isCommonCourseCategory
    }
  }
`;
